import { render, staticRenderFns } from "./pengajuan-sidang.vue?vue&type=template&id=4bcea7a8"
import script from "./pengajuan-sidang.vue?vue&type=script&lang=js"
export * from "./pengajuan-sidang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports